import { render } from "./Edit.vue?vue&type=template&id=7676da14&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=7676da14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7676da14"],['__file',"src/views/ProductTransfers/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7676da14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7676da14', __exports__)) {
    api.reload('7676da14', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=7676da14&scoped=true", () => {
    api.rerender('7676da14', render)
  })

}


export default __exports__